import React, { useEffect, useState } from "react";
import { post } from "../../helpers/api_helper";
//redux
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Form, Input, Label, Row } from "reactstrap";
import Loader from "common/loader";
import { Trans } from "react-i18next";
import Breadcrumb from "components/Common/Breadcrumb";
import { ADD_SCREEN } from "helpers/api_endpoints";

const AddScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [currentVersion, setCurrentVersion] = useState('');
    const [status, setStatus] = useState(0);
    const [name, setName] = useState('');
    const [title, setTitle] = useState('');

    useEffect(() => {
        setLoading(false);
    }, []);

    const handleSubmit = () => {
        post(ADD_SCREEN, { name, title, currentVersion, status })
            .then(response => {
                if (response.code == 201) {
                    navigate('/screens', { state: { successMsg: 'Added SuccessFully' } });
                }
            })
            .catch(error => {

            })
    }

    const handleToggleCheckBoxStatus = () => {
        if (status) {
            setStatus(0);
        }
        else {
            setStatus(1)
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumb title="Screens" breadcrumbItem="Add Screen" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Name</Trans></Label>
                                                    <Input
                                                        name="title"
                                                        value={name}
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        type="text"
                                                        onChange={(e) => setName(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Title</Trans></Label>
                                                    <Input
                                                        name="title"
                                                        value={title}
                                                        className="form-control"
                                                        placeholder="Enter Title"
                                                        type="text"
                                                        onChange={(e) => setTitle(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Current Version</Trans></Label>
                                                    <Input
                                                        name="title"
                                                        value={currentVersion}
                                                        className="form-control"
                                                        placeholder="Enter Current Version"
                                                        type="text"
                                                        onChange={(e) => setCurrentVersion(e.target.value)}
                                                        required ></Input>
                                                </div>

                                                <div className="form-group col-md-3 mt-2">
                                                    <Label className="form-label"><Trans>Status</Trans></Label>
                                                    <div className="form-check form-check-end">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value={1}
                                                            id="defaultCheck2"
                                                            defaultChecked={status == 1}
                                                            onClick={handleToggleCheckBoxStatus}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="defaultCheck2"
                                                        >
                                                            <Trans>Active</Trans>
                                                        </label>
                                                    </div>
                                                </div>



                                                <div className="text-center  mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AddScreen;